<script>
import Icon from 'element-ui/lib/icon';

export default Icon;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/icon.css';
</style>
